import type { ChangeEvent, MouseEvent } from 'react';
import { useRef } from 'react';

interface UseFileInputProps {
    onFileSelect: (file: File) => void;
    multiple?: boolean;
}

interface FileInputControls {
    fileInputRef: React.RefObject<HTMLInputElement | null>;
    openFileDialog: () => void;
    handleFileInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
    clearInputValue: (e: MouseEvent<HTMLInputElement>) => void;
}

export const useFileInput = ({ onFileSelect, multiple = false }: UseFileInputProps): FileInputControls => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const openFileDialog = () => {
        fileInputRef.current?.click();
    };

    const handleFileInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const selectedFiles = Array.from(e.target.files);
            const filesToProcess = multiple ? selectedFiles : selectedFiles.slice(0, 1);

            for (const file of filesToProcess) {
                onFileSelect(file);
            }
        }
    };

    const clearInputValue = (e: MouseEvent<HTMLInputElement>) => {
        e.currentTarget.value = '';
    };

    return {
        fileInputRef,
        openFileDialog,
        handleFileInputChange,
        clearInputValue,
    };
};
